import React, { Component } from "react";
import Select from "react-select";
import "../../Styles/Pages/reactselect.scss";
import ToolTip from "../../HOC/ToolTip";

const colourStyles = {
	control: (provided, state) => ({
		...provided,
		borderColor: state.isFocused || state.isHover ? "#232f49" : "#d4d5d8;",
		boxShadow: "none",
		backgroundColor: "white",
		"&:hover": {
			borderColor: state.isFocused || state.isHover ? "#232f49" : "#d4d5d8;",
			boxShadow: "none",
		},
	}),
	option: (styles, { isDisabled, isFocused, isSelected }) => {
		return {
			...styles,
			backgroundColor: isDisabled
				? null
				: isSelected
				? "#f1f2f4"
				: isFocused
				? "#e9ebed"
				: null,
			color: isDisabled
				? "#ccc"
				: isSelected
				? "#232f49"
					? "#232f49"
					: "#232f49"
				: "#232f49",
			cursor: isDisabled ? "not-allowed" : "default",
			borderColor: isFocused ? "#232f49" : "#d4d5d8",
			boxShadow: "none",
			":active": {
				...styles[":active"],
				backgroundColor: !isDisabled && (isSelected ? "#f1f2f4" : "#fff"),
			},
		};
	},
	menu: styles => ({
		...styles,
		borderRadius: "0px",
		marginTop: "-7px",
		fontSize: "85%",
		padding: "0px",
		borderBottomRightRadius: "5px",
		borderBottomLeftRadius: "5px",
		cursor: "pointer",
		border: "1px solid #d4d5d8",
		minHeight: "46px",
		boxShadow: "none !important",
	}),
	menuList: styles => ({
		...styles,
		padding: "0px",
		zIndez: 4,
		maxHeight: "130px",
		overflowY: "auto",
	}),
	group: styles => ({
		...styles,
		paddingBottom: "4px",
	}),
	groupHeading: styles => ({
		...styles,
		paddingTop: "4px",
		paddingBottom: "4px",
	}),
};

const errorStyles = {
	control: (provided, state) => ({
		...provided,
		borderColor:
			state.isFocused || state.isHover ? "red !important" : "red !important",
		boxShadow: "none",
		backgroundColor: "white",

		"&:hover": {
			borderColor:
				state.isFocused || state.isHover ? "red !important" : "red !important",
			boxShadow: "none",
		},
	}),
	option: (styles, { isDisabled, isFocused, isSelected }) => {
		return {
			...styles,
			backgroundColor: isDisabled
				? null
				: isSelected
				? "#f1f2f4"
				: isFocused
				? "#e9ebed"
				: null,
			color: isDisabled
				? "#ccc"
				: isSelected
				? "#232f49"
					? "#232f49"
					: "#232f49"
				: "#232f49",
			cursor: isDisabled ? "not-allowed" : "default",
			borderColor: isFocused ? "#232f49" : "#d4d5d8",
			boxShadow: "none",
			":active": {
				...styles[":active"],
				backgroundColor: !isDisabled && (isSelected ? "#f1f2f4" : "#fff"),
			},
		};
	},
	menu: styles => ({
		...styles,
		boxShadow: "none",
		borderRadius: "0px",
		marginTop: "-7px",
		fontSize: "85%",
		padding: "0px",
		minHeight: "5px !important",
		borderBottomRightRadius: "5px",
		borderBottomLeftRadius: "5px",
		cursor: "pointer",
		backgroundColor: "#fff",
	}),
	menuList: styles => ({
		...styles,
		padding: "0px",
	}),
};

class ReactSelect extends Component {
	constructor(props) {
		super(props);
		this.selectRef = React.createRef();
	}

	render() {
		const props = this.props;
		return (
			<div
				className={`react-select-section ${
					this.props.isDisabled ? "is-disabled" : ""
				} ${this.props.hideRemoveIcon ? "hide-remove-icon" : ""} ${
					this.props.noOptionsWrap ? "no-options-wrap" : ""
				}`}
				style={{
					marginBottom: props.withMargin ? "20px" : "",
					zIndex: props.zIndex || "",
				}}
				ref={this.selectRef}
				onClick={() =>
					props.autoScroll ? this.selectRef.current.scrollIntoView() : null
				}
			>
				<div className="form__label">
					{props.label}
					{props.required ? (
						<span
							style={{ color: "#ff0505", paddingLeft: "1px", opacity: "0.7" }}
						>
							*
						</span>
					) : (
						""
					)}
					{props.tooltipText && (
						<ToolTip
							adjustParentStyle={true}
							width={props.tooltipWidth || 170}
							position="top"
						>
							{props.tooltipText}
						</ToolTip>
					)}
				</div>
				<Select
					options={props.options}
					//  value={props.value}
					//  {...(props.isMulti && { value: props.value })}
					{...(props.isDisabled && { isDisabled: true })}
					{...(props.menuPlacement && { menuPlacement: props.menuPlacement })}
					{...(props.menuPosition && { menuPosition: props.menuPosition })}
					{...(props.ref && { ref: props.ref })}
					value={props.value}
					defaultValue={props.value}
					isMulti={props.isMulti}
					isLoading={props.isLoading}
					placeholder={props.placeholder}
					onChange={props.onChange}
					styles={this.props.errorText ? errorStyles : colourStyles}
					openMenuOnClick={!props.hideOnClick}
					noOptionsMessage={() => {
						return props.emptyText === "hide"
							? ""
							: props.emptyText || "no option found";
					}}
					isClearable={!props.hideClearButton}
				/>
				{props.errorText && (
					<span
						style={{
							position: "absolute",
							fontSize: "11px",
							color: "red",
							bottom: "-17px",
						}}
					>
						{props.errorText}
					</span>
				)}
			</div>
		);
	}
}

export default ReactSelect;
